import { store } from 'store';
import { getFromLocal, saveToLocal } from './localStorage';
import { fetcher } from './axios';

//* Performance log
export const writePerformanceLog = (storageItemName: string, data: any) => {
  const savedUserData = store.getState().user || getFromLocal('userData');
  const savedData = getFromLocal(storageItemName) ?? [];
  savedData.push({
    companyId: savedUserData?.CompanyId || '',
    userId: savedUserData?.Udid || '',
    data,
  });
  saveToLocal(storageItemName, savedData);
};
export const clearPerformanceLog = (storageItemName: string) => {
  localStorage.removeItem(storageItemName);
};

export async function checkAndUpdateFireberryPerformanceLog() {
  try {
    const savedData = getFromLocal('fireberryPlaceChatPerformanceLog') ?? [];
    if (savedData.length) {
      const lastSavedLogDate = savedData[savedData.length - 1].date;

      if (isMoreThanTwoHours(lastSavedLogDate)) {
        console.log(lastSavedLogDate);

        const data = await fetcher(
          'post',
          ['/api/services/getExtensionPerformanceLog', { data: { log: savedData } }],
          'priority',
        );

        if (data) {
          clearPerformanceLog('fireberryPlaceChatPerformanceLog');
        }
      }
    }
  } catch (error) {
    console.error('checkAndUpdateFireberryPerformanceLog error: ', error);
  }

  function isMoreThanTwoHours(dateISOString: string) {
    const savedDate = new Date(dateISOString);
    const now = new Date();

    const diffInMilliseconds = now.getTime() - savedDate.getTime();
    const diffInHours = diffInMilliseconds / (1000 * 60 * 60);

    return diffInHours > 2;
  }
}
